var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tabItem) {
            return _c("v-tab", { key: tabItem }, [
              _vm._v("\n      " + _vm._s(_vm.$t(tabItem)) + "\n    ")
            ])
          }),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { "justify-center": "", "align-center": "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { dark: "", color: "primary" },
                  on: { click: _vm.showExportOrdersPopup }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("exportOrders")) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { "justify-center": "", "align-center": "" } },
            [
              _vm.currentTab === "active" &&
              _vm.fulfillmentOrders &&
              _vm.fulfillmentOrders.length
                ? _c(
                    "v-flex",
                    {
                      staticStyle: {
                        "white-space": "nowrap",
                        "text-align": "center",
                        cursor: "pointer"
                      },
                      on: {
                        click: function($event) {
                          _vm.tab = 2
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { color: "orange" } }, [
                        _vm._v("info")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "dodgerblue",
                            "text-decoration": "underline"
                          }
                        },
                        [
                          _vm._v(
                            "\n          You have orders in fulfill page\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(_vm.tabs, function(item, index) {
              return _c(
                "v-tab-item",
                { key: index },
                [
                  item === "active" && _vm.currentTab === "active"
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "justify-space-between": "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs6: "", md12: "", xl8: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "UploadFileWidget",
                                        {
                                          ref: "fileUploader",
                                          refInFor: true,
                                          staticStyle: { "max-width": "150px" },
                                          attrs: {
                                            type: "order",
                                            maxFiles: 1,
                                            clearFiles: _vm.clearFiles,
                                            small: "",
                                            loading: _vm.loading
                                          },
                                          on: {
                                            filesStatus: function(status) {
                                              return (
                                                status === "done" &&
                                                _vm.uploadedFiles.length &&
                                                _vm.uploadOrders()
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.uploadedFiles,
                                            callback: function($$v) {
                                              _vm.uploadedFiles = $$v
                                            },
                                            expression: "uploadedFiles"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("uploadOrders")))]
                                      ),
                                      _vm._v(" "),
                                      !_vm.isOrgLabel
                                        ? _c(
                                            "vite-module-container",
                                            {
                                              attrs: {
                                                moduleNames: ["shipment"]
                                              }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    loading:
                                                      _vm.buyShippingDialogRunning,
                                                    disabled:
                                                      _vm.selectedOrders
                                                        .length === 0 ||
                                                      _vm.isMPSOrder ||
                                                      _vm.buyShippingDialogRunning
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showBuyShippingDialog()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "createShipments"
                                                        )
                                                      ) +
                                                      "(" +
                                                      _vm._s(
                                                        _vm.selectedOrders
                                                          .length -
                                                          _vm.selectedMPSOrdersLen
                                                      ) +
                                                      ")\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            loading: _vm.buyLabelDialogRunning,
                                            disabled:
                                              _vm.selectedOrders.length === 0 ||
                                              _vm.isMPSOrder ||
                                              _vm.buyLabelDialogRunning
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.showBuyLabelDialog()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("createLabels")) +
                                              "(" +
                                              _vm._s(
                                                _vm.selectedOrders.length -
                                                  _vm.selectedMPSOrdersLen
                                              ) +
                                              ")\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-menu",
                                        {
                                          class: "hidden-sm-and-down",
                                          attrs: { "offset-y": "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.selectedMPSOrdersLen ===
                                                              0 ||
                                                            _vm.buyShippingDialogRunning,
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return on.click.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "createMPSLabel"
                                                              )
                                                            ) +
                                                            "(" +
                                                            _vm._s(
                                                              _vm.selectedMPSOrdersLen
                                                            ) +
                                                            ")\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        loading:
                                                          _vm.buyLabelDialogRunning,
                                                        disabled:
                                                          _vm.selectedOrders
                                                            .length === 0 ||
                                                          _vm.selectedOrders.every(
                                                            function(order) {
                                                              return !order.isMPS
                                                            }
                                                          ) ||
                                                          _vm.buyLabelDialogRunning
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showBuyLabelDialog(
                                                            true
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "createMPSLabels"
                                                            )
                                                          ) +
                                                          "(" +
                                                          _vm._s(
                                                            _vm.selectedMPSOrdersLen
                                                          ) +
                                                          ")\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              [
                                                _c(
                                                  "vite-module-container",
                                                  {
                                                    attrs: {
                                                      moduleNames: ["shipment"]
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              flat: "",
                                                              loading:
                                                                _vm.buyShippingDialogRunning,
                                                              disabled:
                                                                _vm
                                                                  .selectedOrders
                                                                  .length ===
                                                                  0 ||
                                                                _vm.selectedOrders.every(
                                                                  function(
                                                                    order
                                                                  ) {
                                                                    return !order.isMPS
                                                                  }
                                                                ) ||
                                                                _vm.buyLabelDialogRunning
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.showBuyShippingDialog(
                                                                  true
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "createMPSShipments"
                                                                  )
                                                                ) +
                                                                "(" +
                                                                _vm._s(
                                                                  _vm.selectedMPSOrdersLen
                                                                ) +
                                                                ")\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            disabled:
                                              _vm.selectedOrders.length === 0
                                          },
                                          on: { click: _vm.batchCancel }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("cancel/archiveSelected")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticStyle: { "min-width": "10rem" },
                                          attrs: { md3: "" }
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.stores,
                                              "item-text": "accountName",
                                              label: _vm.$t(
                                                "selectStorePullOrders"
                                              ),
                                              clearable: "",
                                              multiple: "",
                                              "return-object": ""
                                            },
                                            model: {
                                              value: _vm.storePullOrders,
                                              callback: function($$v) {
                                                _vm.storePullOrders = $$v
                                              },
                                              expression: "storePullOrders"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { right: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(tooltip) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      _vm._g({}, tooltip.on),
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              color: "primary",
                                                              disabled:
                                                                _vm.pullOrderLastTimeDisabled ||
                                                                _vm.isDisabledPullOrder,
                                                              loading:
                                                                _vm.processEcomLoading
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.pullOrders(
                                                                  _vm.storePullOrders
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "pullOrder"
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                            _vm.pullOrderUpdateLoading
                                                              ? _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mx-2 loading",
                                                                    attrs: {
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "hourglass_empty"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _vm.isDisabledPullOrder
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "selectStorePullOrders"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            : _c(
                                                "span",
                                                [
                                                  _vm._l(
                                                    _vm.storePullOrders,
                                                    function(storePullOrder) {
                                                      return [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              storePullOrder.accountName
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        _c("br", {
                                                          key:
                                                            storePullOrder.accountId +
                                                            "-1"
                                                        }),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "orderLastRequestTime"
                                                              ) +
                                                                "：" +
                                                                (storePullOrder &&
                                                                (storePullOrder.orderLastRequestTime ||
                                                                  storePullOrder.orderLastUpdateTime)
                                                                  ? _vm.toTimestampString(
                                                                      new Date(
                                                                        storePullOrder.orderLastRequestTime ||
                                                                          storePullOrder.orderLastUpdateTime
                                                                      )
                                                                    )
                                                                  : "N/A")
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        _c("br", {
                                                          key:
                                                            storePullOrder.accountId +
                                                            "-2"
                                                        }),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "orderLastUpdateTime"
                                                              ) +
                                                                "：" +
                                                                (storePullOrder &&
                                                                storePullOrder.orderLastUpdateTime
                                                                  ? _vm.toTimestampString(
                                                                      new Date(
                                                                        storePullOrder.orderLastUpdateTime
                                                                      )
                                                                    )
                                                                  : "N/A")
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        _c("br", {
                                                          key:
                                                            storePullOrder.accountId +
                                                            "-3"
                                                        }),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              storePullOrder &&
                                                                storePullOrder.pullOrderErrorMessage
                                                                ? _vm.$t(
                                                                    "pullOrderErrorMessage"
                                                                  ) +
                                                                    "：" +
                                                                    _vm.$t(
                                                                      "EcomRequestError." +
                                                                        storePullOrder.pullOrderErrorMessage
                                                                    )
                                                                : ""
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pullOrderCDTime",
                                                          {
                                                            pullOrderCDTime:
                                                              _vm.pullOrderCDTime
                                                          }
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ],
                                                2
                                              )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", md2: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "filter_list",
                                      label: _vm.$t("search"),
                                      "single-line": "",
                                      "hide-details": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter,
                                      callback: function($$v) {
                                        _vm.filter = $$v
                                      },
                                      expression: "filter"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.errorAlert || _vm.alert
                            ? _c(
                                "v-layout",
                                {
                                  attrs: {
                                    "justify-center": "",
                                    "mb-3": "",
                                    "mt-2": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md10: "" } },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          attrs: {
                                            dismissible: "",
                                            outline: "",
                                            type: "error"
                                          },
                                          model: {
                                            value: _vm.errorAlert,
                                            callback: function($$v) {
                                              _vm.errorAlert = $$v
                                            },
                                            expression: "errorAlert"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.errorMessage))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-alert",
                                        {
                                          style: {
                                            whiteSpace: "pre-wrap"
                                          },
                                          attrs: {
                                            value: _vm.alert,
                                            dismissible: "",
                                            outline: "",
                                            type: _vm.alertType
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.alertMsg))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-start": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "success--text caption",
                                  attrs: { xs2: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "realtime-border px-1" },
                                    [_vm._v(_vm._s(_vm.$t("realTIME")))]
                                  ),
                                  _vm._v(" "),
                                  _vm.orders.length < _vm.orderQtyLimit
                                    ? _c(
                                        "span",
                                        { staticClass: "realtime-border px-1" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("orderQty", {
                                                quantity: _vm.orders.length
                                              })
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "realtime-border px-1" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("orderQty", {
                                                quantity: _vm.orderQtyLimit
                                              }) + "+"
                                            )
                                          )
                                        ]
                                      )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-flex", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "supportAmazon/ebay/walmart/newegg/"
                                      )
                                    ) +
                                    "\n              "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: { linkify: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.getStandTemplate()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("standard")) + " / ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: { linkify: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.getStandTemplate(true)
                                      }
                                    }
                                  },
                                  [_vm._v("MPSstandard")]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs2: "" } },
                                [
                                  _c("DatePicker", {
                                    attrs: {
                                      label: _vm.$t("date"),
                                      range: "",
                                      max: _vm.activeDateMax,
                                      min: _vm.activeDateMin
                                    },
                                    model: {
                                      value: _vm.dates,
                                      callback: function($$v) {
                                        _vm.dates = $$v
                                      },
                                      expression: "dates"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          item === "active" && _vm.currentTab === "active"
                            ? _c("v-data-table", {
                                ref: "activeOrders",
                                refInFor: true,
                                attrs: {
                                  headers: _vm.headers,
                                  search: _vm.filter,
                                  items: _vm.orders,
                                  "select-all": "blue",
                                  pagination: _vm.pagination,
                                  "item-value": "_indexKey",
                                  "item-key": "_indexKey",
                                  "rows-per-page-items": _vm.rowPerPage,
                                  expand: _vm.expand
                                },
                                on: {
                                  "update:pagination": function($event) {
                                    _vm.pagination = $event
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "headers",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "tr",
                                            { staticClass: "active-headers" },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "checkbox-align-center"
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          value: props.all,
                                                          primary: "",
                                                          "hide-details": "",
                                                          indeterminate: !!_vm
                                                            .selectedOrders
                                                            .length
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.toggleAll.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: { width: "15%" }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "align-center": ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.sortOrders(
                                                            "purchaseDate"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "header-date"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "orderDate"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                          _vm.sortTable
                                                            .param ===
                                                          "purchaseDate"
                                                            ? [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    class: {
                                                                      "header-date-arrow-desc":
                                                                        _vm
                                                                          .sortTable
                                                                          .type ===
                                                                        "desc"
                                                                    },
                                                                    attrs: {
                                                                      size: "14"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "arrow_upward"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "align-center": ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.sortOrders(
                                                            "updateDate"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "header-date"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "updateTime"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                          _vm.sortTable
                                                            .param ===
                                                          "updateDate"
                                                            ? [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    class: {
                                                                      "header-date-arrow-desc":
                                                                        _vm
                                                                          .sortTable
                                                                          .type ===
                                                                        "desc"
                                                                    },
                                                                    attrs: {
                                                                      size: "14"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "arrow_upward"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-align-center",
                                                  staticStyle: { width: "10%" }
                                                },
                                                [
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("orderDetail")
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-align-center"
                                                },
                                                [
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("productInfo")
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-align-center"
                                                },
                                                [
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("buyerInfo")
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-align-center"
                                                },
                                                [
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "serviceLevel/AddressType"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-justify-center"
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-center": ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("template")
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "text-justify-center",
                                                  staticStyle: { width: "10%" }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-center": ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("actions")
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "checkbox-align-center",
                                              on: {
                                                click: function($event) {
                                                  !props.item.isDisabled &&
                                                    (props.selected = !props.selected)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      disabled:
                                                        props.item.isDisabled,
                                                      value: props.selected,
                                                      primary: "",
                                                      "hide-details": ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return function() {
                                                          props.selected = !props.selected
                                                        }.apply(null, arguments)
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.toTimestampString(
                                                    props.item.purchaseDate
                                                  )
                                                )
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.toTimestampString(
                                                    props.item.updateDate
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c("OrderDetail", {
                                                attrs: {
                                                  orderType: props.item.isMPS,
                                                  storeName:
                                                    props.item.storeName,
                                                  orderId:
                                                    props.item.orderName ||
                                                    props.item.orderId,
                                                  platform: props.item.platform,
                                                  messages: props.item.messages,
                                                  orderStatus:
                                                    props.item.cancelState
                                                }
                                              }),
                                              _vm._v(" "),
                                              !!props.item.error
                                                ? _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-start": "",
                                                        wrap: "",
                                                        "align-start": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "red"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Shipment Error: " +
                                                              _vm._s(
                                                                props.item.error
                                                                  .message
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            _vm._l(props.item.items, function(
                                              item,
                                              index
                                            ) {
                                              return _c(
                                                "v-flex",
                                                {
                                                  key: item.sku + index,
                                                  attrs: { row: "" }
                                                },
                                                [
                                                  _c("ProductWidget", {
                                                    attrs: {
                                                      name: item.productName,
                                                      sku: [item.sku],
                                                      quantityShipped:
                                                        item.quantityShipped,
                                                      quantityPurchased:
                                                        item.quantityPurchased,
                                                      status:
                                                        item.productStatus,
                                                      isMatchingExactly:
                                                        props.item
                                                          .exactMatchTemplate,
                                                      isSupportChanged: ""
                                                    },
                                                    on: {
                                                      "submit-quantity": function(
                                                        value
                                                      ) {
                                                        return _vm.updateQuantity(
                                                          props.item.orderId,
                                                          item.orderItemId,
                                                          value
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "sku",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "ml-2"
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      on: {
                                                                        click: function() {
                                                                          _vm.filter =
                                                                            item.sku
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.sku
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "text-sm-left"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("shipBy")
                                                            ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm.toDateString(
                                                                  props.item
                                                                    .promiseDate
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c("v-layout", [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(props.item.buyerName)
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("v-layout", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      props.item.recipientName
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-layout", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      props.item.shipAddress1 +
                                                        props.item.shipAddress2
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-layout", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      props.item.shipCity
                                                    ) +
                                                    " - " +
                                                    _vm._s(
                                                      props.item.shipState
                                                    ) +
                                                    " -\n                  " +
                                                    _vm._s(
                                                      props.item.shipPostalCode
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-layout", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      props.item
                                                        .buyerPhoneNumber
                                                    ) +
                                                    "\n                "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              props.item.buyerNotes
                                                ? _c("v-layout", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item.buyerNotes
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c("v-layout", [
                                                _c(
                                                  "span",
                                                  {
                                                    style:
                                                      "color: " +
                                                      (props.item
                                                        .shipServiceLevel ===
                                                        "ShippingMethodExpress" ||
                                                      (props.item.platform ===
                                                        "Amazon" &&
                                                        props.item
                                                          .shipServiceLevel ===
                                                          "NextDay") ||
                                                      (props.item.platform ===
                                                        "Amazon" &&
                                                        props.item
                                                          .shipServiceLevel ===
                                                          "SecondDay") ||
                                                      props.item
                                                        .shipServiceLevel ===
                                                        "Express"
                                                        ? "red"
                                                        : "black")
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item
                                                          .shipServiceLevel
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "/" +
                                                      _vm._s(
                                                        props.item
                                                          .isBusinessOrder
                                                          ? _vm.$t("business")
                                                          : _vm.$t("other")
                                                      )
                                                  )
                                                ])
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.templates.find(function(
                                            template
                                          ) {
                                            return (
                                              props.item.items.length === 1 &&
                                              props.item.items.some(function(
                                                item
                                              ) {
                                                return (
                                                  item.sku === template.sku ||
                                                  template.sku.includes(
                                                    item.sku
                                                  )
                                                )
                                              })
                                            )
                                          }) && props.item.matchedTemplateName
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(
                                                              tooltip
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {
                                                                      style: {
                                                                        background: props
                                                                          .item
                                                                          .exactMatchTemplate
                                                                          ? ""
                                                                          : "yellow"
                                                                      }
                                                                    },
                                                                    tooltip.on
                                                                  ),
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          props
                                                                            .item
                                                                            .matchedTemplateName
                                                                        )
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            props.item
                                                              .exactMatchTemplate
                                                              ? _vm.$t(
                                                                  "skuAndQtyAllMatched"
                                                                )
                                                              : _vm.$t(
                                                                  "skuMatchedQtyUnmatch"
                                                                )
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : props.item.items.length === 1
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        dark: "",
                                                        flat: "",
                                                        icon: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.showTemplateDialog(
                                                            props.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("add")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c("td", {
                                                staticClass: "text-xs-left"
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    "justify-center": "",
                                                    "no-wrap": ""
                                                  }
                                                },
                                                [
                                                  !props.item.isApiOrder
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "",
                                                                              flat:
                                                                                "",
                                                                              dark:
                                                                                "",
                                                                              color:
                                                                                "primary"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.showRevisePkg(
                                                                                  props.item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "widgets"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "modifyPkgSpecification"
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !_vm.isOrgLabel
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "vite-module-container",
                                                                          {
                                                                            attrs: {
                                                                              moduleNames: [
                                                                                "shipment"
                                                                              ]
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                attrs: {
                                                                                  dark:
                                                                                    "",
                                                                                  flat:
                                                                                    "",
                                                                                  icon:
                                                                                    "",
                                                                                  color:
                                                                                    "primary"
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.showAddShipmentSingle(
                                                                                      props.item
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "local_shipping"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "addShipmentFromOrder"
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  props.item.items.some(
                                                    function(item) {
                                                      return (
                                                        item.quantityShipped > 0
                                                      )
                                                    }
                                                  )
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "",
                                                                              flat:
                                                                                "",
                                                                              dark:
                                                                                "",
                                                                              color:
                                                                                "primary",
                                                                              loading:
                                                                                props
                                                                                  .item
                                                                                  .archiveLoading
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.archiveOrder(
                                                                                  props.item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "archive"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "archiveOrder"
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "",
                                                                              flat:
                                                                                "",
                                                                              dark:
                                                                                "",
                                                                              color:
                                                                                "primary",
                                                                              loading:
                                                                                props
                                                                                  .item
                                                                                  .loading
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.cancelOrder(
                                                                                  props.item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "cancel"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "cancelOrder"
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(
                                                              tooltip
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip.on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "",
                                                                          flat:
                                                                            "",
                                                                          dark:
                                                                            "",
                                                                          color:
                                                                            "primary"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.showRemarkOrderPopup(
                                                                              props.item
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "note"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "remarkOrder"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(
                                                              tooltip
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip.on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "",
                                                                          flat:
                                                                            "",
                                                                          dark:
                                                                            "",
                                                                          color:
                                                                            "primary"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.showSplitOrderPopup(
                                                                              props.item
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticStyle: {
                                                                              transform:
                                                                                "rotate(90deg)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "splitscreen"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t("splitOrder")
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.selectedFilteredOrders,
                                  callback: function($$v) {
                                    _vm.selectedFilteredOrders = $$v
                                  },
                                  expression: "selectedFilteredOrders"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item === "pendingShipment" &&
                  _vm.currentTab === "pendingShipment"
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                layout: "",
                                "align-content-space-around": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "mb-3": "", md10: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.enabledSelectedShipmentOrders
                                                .length === 0 ||
                                              _vm.processOrderShipmentLoading,
                                            loading:
                                              _vm.processOrderShipmentLoading,
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.retryOrderShipment(
                                                _vm.enabledSelectedShipmentOrders
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("retry")) +
                                              " (" +
                                              _vm._s(
                                                _vm
                                                  .enabledSelectedShipmentOrders
                                                  .length
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", md2: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "filter_list",
                                      label: _vm.$t("search"),
                                      "single-line": "",
                                      "hide-details": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter,
                                      callback: function($$v) {
                                        _vm.filter = $$v
                                      },
                                      expression: "filter"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-start": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "success--text caption",
                                  attrs: { xs2: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "realtime-border px-1" },
                                    [_vm._v(_vm._s(_vm.$t("realTIME")))]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            attrs: {
                              headers: _vm.shipmentHeaders,
                              items: _vm.shipmentOrders.filter(function(item) {
                                return _vm.filter
                                  ? item.orderId.includes(_vm.filter)
                                  : true
                              }),
                              "item-key": "_key",
                              "select-all": "blue",
                              expand: _vm.expand,
                              pagination: _vm.pagination,
                              "rows-per-page-items": _vm.rowPerPage
                            },
                            on: {
                              "update:pagination": function($event) {
                                _vm.pagination = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "checkbox-align-center",
                                          on: {
                                            click: function() {
                                              !props.item.isDisabled &&
                                                (props.selected = !props.selected)
                                              if (props.item.isDisabled) {
                                                props.selected = false
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  disabled:
                                                    props.item.isDisabled,
                                                  value: props.selected,
                                                  primary: "",
                                                  "hide-details": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return function() {
                                                      props.selected = !props.selected
                                                    }.apply(null, arguments)
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("OrderDetail", {
                                            attrs: {
                                              orderId: props.item.orderId,
                                              platform: props.item.platform,
                                              messages:
                                                props.item.messages || [],
                                              storeName: props.item.storeName
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-start": "",
                                                wrap: "",
                                                "align-start": ""
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("orderDate")) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.toTimestampString(
                                                        props.item.purchaseDate
                                                      )
                                                    )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-start": "",
                                                wrap: "",
                                                "align-start": ""
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("processDate")
                                                  ) +
                                                    ":\n                    " +
                                                    _vm._s(
                                                      _vm.toTimestampString(
                                                        props.item.processTime
                                                      )
                                                    )
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("LabelAddressWidget", {
                                            attrs: {
                                              address:
                                                props.item.label &&
                                                props.item.label.from
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("LabelAddressWidget", {
                                            attrs: {
                                              address:
                                                props.item.label &&
                                                props.item.label.to
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          props.item.processStatus === "failed"
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: { color: "red" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          props.item.error
                                                            ? props.item.error
                                                                .message
                                                            : ""
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(props.item.processStatus)
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          props.item.processStatus === "failed"
                                            ? _c(
                                                "v-menu",
                                                {
                                                  attrs: { "offset-y": "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-tooltip",
                                                              {
                                                                attrs: {
                                                                  top: ""
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "activator",
                                                                      fn: function(
                                                                        tooltip
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "div",
                                                                            _vm._g(
                                                                              {},
                                                                              tooltip.on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-btn",
                                                                                {
                                                                                  attrs: {
                                                                                    dark:
                                                                                      "",
                                                                                    icon:
                                                                                      "",
                                                                                    flat:
                                                                                      "",
                                                                                    color:
                                                                                      "primary"
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      $event.stopPropagation()
                                                                                      return on.click.apply(
                                                                                        null,
                                                                                        arguments
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "build"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                )
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "more"
                                                                      )
                                                                    ) +
                                                                    "\n                    "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list",
                                                    [
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          staticClass:
                                                            "list-tile-center"
                                                        },
                                                        [
                                                          _c("LoaderButton", {
                                                            attrs: {
                                                              flat: "",
                                                              buttonText: _vm.$t(
                                                                "edit"
                                                              ),
                                                              disabled:
                                                                props.item
                                                                  .isDisabled,
                                                              promiseAwait:
                                                                _vm.editLabel,
                                                              promiseItem:
                                                                props.item
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list",
                                                    [
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          staticClass:
                                                            "list-tile-center"
                                                        },
                                                        [
                                                          _c("LoaderButton", {
                                                            attrs: {
                                                              flat: "",
                                                              disabled:
                                                                props.item
                                                                  .isDisabled,
                                                              buttonText: _vm.$t(
                                                                "delete"
                                                              ),
                                                              promiseAwait:
                                                                _vm.deleteShipmentTask,
                                                              promiseItem:
                                                                props.item
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.selectedShipmentOrders,
                              callback: function($$v) {
                                _vm.selectedShipmentOrders = $$v
                              },
                              expression: "selectedShipmentOrders"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item === "fulfillment" && _vm.currentTab === "fulfillment"
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                layout: "",
                                "align-content-space-around": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "mb-3": "", md10: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(tooltip) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      _vm._g({}, tooltip.on),
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm
                                                                  .selectedFulfillments
                                                                  .length === 0,
                                                              loading:
                                                                _vm.processEcomLoading,
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.markFulfillment(
                                                                  _vm.selectedFulfillments
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "fulfill"
                                                                )
                                                              ) +
                                                                " (" +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedFulfillments
                                                                    .length
                                                                ) +
                                                                ")"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("submitFulfillment")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-menu",
                                        {
                                          class: "hidden-sm-and-down",
                                          attrs: { "offset-y": "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm
                                                              .selectedFulfillments
                                                              .length === 0,
                                                          loading:
                                                            _vm.reverseFulfillLoading ||
                                                            _vm.closeFulfillLoading,
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return on.click.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t("more")
                                                            ) +
                                                            "(" +
                                                            _vm._s(
                                                              _vm
                                                                .selectedFulfillments
                                                                .length
                                                            ) +
                                                            ")\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(
                                                              tooltip
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip.on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm
                                                                              .selectedFulfillments
                                                                              .length ===
                                                                            0,
                                                                          loading:
                                                                            _vm.reverseFulfillLoading,
                                                                          flat:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.setOrderStatus(
                                                                              _vm.selectedFulfillments,
                                                                              "open"
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "reverse"
                                                                            )
                                                                          ) +
                                                                            " (" +
                                                                            _vm._s(
                                                                              _vm
                                                                                .selectedFulfillments
                                                                                .length
                                                                            ) +
                                                                            ")"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "moveToActive"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(
                                                              tooltip
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip.on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm
                                                                              .selectedFulfillments
                                                                              .length ===
                                                                            0,
                                                                          loading:
                                                                            _vm.closeFulfillLoading,
                                                                          flat:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.setOrderStatus(
                                                                              _vm.selectedFulfillments,
                                                                              "closed"
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "close"
                                                                            )
                                                                          ) +
                                                                            " (" +
                                                                            _vm._s(
                                                                              _vm
                                                                                .selectedFulfillments
                                                                                .length
                                                                            ) +
                                                                            ")"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "moveToHistory"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: { xs2: "", md2: "" }
                                },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: _vm.$t("store"),
                                      items: _vm.stores,
                                      "item-text": "accountName",
                                      "item-value": "accountId",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.store,
                                      callback: function($$v) {
                                        _vm.store = $$v
                                      },
                                      expression: "store"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: { xs2: "", md2: "" }
                                },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: _vm.$t("status"),
                                      items: _vm.fulfillmentOrderStatuses,
                                      "item-text": "label"
                                    },
                                    model: {
                                      value: _vm.orderStatus,
                                      callback: function($$v) {
                                        _vm.orderStatus = $$v
                                      },
                                      expression: "orderStatus"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", md2: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "filter_list",
                                      label: _vm.$t("search"),
                                      "single-line": "",
                                      "hide-details": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter,
                                      callback: function($$v) {
                                        _vm.filter = $$v
                                      },
                                      expression: "filter"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { "justify-start": "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "success--text caption",
                                  attrs: { xs2: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "realtime-border px-1" },
                                    [_vm._v(_vm._s(_vm.$t("realTIME")))]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            attrs: {
                              headers: _vm.headers,
                              search: _vm.filter,
                              items: _vm.fulfillmentOrders,
                              "item-key": "_indexKey",
                              "select-all": "blue",
                              expand: _vm.expand,
                              pagination: _vm.pagination,
                              "rows-per-page-items": _vm.rowPerPage
                            },
                            on: {
                              "update:pagination": function($event) {
                                _vm.pagination = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "checkbox-align-center",
                                          on: {
                                            click: function($event) {
                                              props.selected = !props.selected
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  value: props.selected,
                                                  primary: "",
                                                  "hide-details": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return function() {
                                                      props.selected = !props.selected
                                                    }.apply(null, arguments)
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("OrderDetail", {
                                            attrs: {
                                              orderId:
                                                props.item.orderName ||
                                                props.item.orderId,
                                              platform: props.item.platform,
                                              messages:
                                                props.item.messages || [],
                                              storeName: props.item.storeName
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-start": "",
                                                wrap: "",
                                                "align-start": ""
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("orderDate")) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.toTimestampString(
                                                        props.item.purchaseDate
                                                      )
                                                    )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-start": "",
                                                wrap: "",
                                                "align-start": ""
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("processDate")
                                                  ) +
                                                    ":\n                    " +
                                                    _vm._s(
                                                      _vm.toTimestampString(
                                                        props.item.processTime
                                                      )
                                                    )
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        _vm._l(props.item.items, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "v-flex",
                                            {
                                              key: item.sku + index,
                                              attrs: { row: "" }
                                            },
                                            [
                                              _c("ProductWidget", {
                                                attrs: {
                                                  name: item.productName,
                                                  sku: [item.sku],
                                                  quantityShipped:
                                                    item.quantityShipped,
                                                  quantityPurchased:
                                                    item.quantityPurchased,
                                                  status: item.productStatus
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("v-layout", [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(props.item.buyerName)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  props.item.recipientName
                                                ) +
                                                " "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  props.item.shipAddress1 +
                                                    props.item.shipAddress2
                                                ) +
                                                " "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(props.item.shipCity) +
                                                " - " +
                                                _vm._s(props.item.shipState) +
                                                " -\n                  " +
                                                _vm._s(
                                                  props.item.shipPostalCode
                                                ) +
                                                "\n                "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  props.item.buyerPhoneNumber
                                                ) +
                                                " "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("v-layout", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  props.item.shipServiceLevel
                                                ) +
                                                " /\n                  " +
                                                _vm._s(
                                                  props.item.isBusinessOrder
                                                    ? _vm.$t("business")
                                                    : _vm.$t("other")
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          props.item.cancelState
                                            ? _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(tooltip) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g(
                                                                {},
                                                                tooltip.on
                                                              ),
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticStyle: {
                                                                      color:
                                                                        "red",
                                                                      "font-weight":
                                                                        "bold"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            props
                                                                              .item
                                                                              .cancelState
                                                                          )
                                                                        ) +
                                                                        "\n                      "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t("canceledOrder")
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(props.item.status)
                                              ) +
                                              "\n              "
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { wrap: "" } },
                                            _vm._l(
                                              props.item.shipments.reduce(
                                                function(preVal, curVal) {
                                                  if (
                                                    !preVal.some(function(ref) {
                                                      var trackingNumber =
                                                        ref.trackingNumber

                                                      return (
                                                        curVal.trackingNumber &&
                                                        trackingNumber ===
                                                          curVal.trackingNumber
                                                      )
                                                    })
                                                  ) {
                                                    preVal.push(curVal)
                                                  }
                                                  return preVal
                                                },
                                                []
                                              ),
                                              function(shipment) {
                                                return _c(
                                                  "v-flex",
                                                  {
                                                    key:
                                                      shipment.key ||
                                                      shipment.labelKey +
                                                        shipment.orderItemId
                                                  },
                                                  [
                                                    _c(
                                                      "LabelTrackingDetailWidget",
                                                      {
                                                        attrs: {
                                                          trackingNumber:
                                                            _vm.getShipmentTracking(
                                                              shipment
                                                            ) !== "No tracking"
                                                              ? _vm.getShipmentTracking(
                                                                  shipment
                                                                )
                                                              : "",
                                                          status: _vm.getOrderTrackingDetail(
                                                            props.item,
                                                            (
                                                              shipment.trackingNumber ||
                                                              ""
                                                            ).trim()
                                                          ).status,
                                                          carrier: _vm.getOrderTrackingDetail(
                                                            props.item,
                                                            (
                                                              shipment.trackingNumber ||
                                                              ""
                                                            ).trim()
                                                          ).carrier,
                                                          details: _vm.getOrderTrackingDetail(
                                                            props.item,
                                                            (
                                                              shipment.trackingNumber ||
                                                              ""
                                                            ).trim()
                                                          ).trackingDetails
                                                        }
                                                      },
                                                      [
                                                        shipment.key
                                                          ? _c("span", [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    shipment.key
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " -\n                        " +
                                                                  _vm._s(
                                                                    _vm.getShipmentTracking(
                                                                      shipment
                                                                    )
                                                                  ) +
                                                                  " -\n                        " +
                                                                  _vm._s(
                                                                    shipment.status
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.selectedFulfillments,
                              callback: function($$v) {
                                _vm.selectedFulfillments = $$v
                              },
                              expression: "selectedFulfillments"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item === "history" && _vm.currentTab === "history"
                    ? _c("PaginationController", {
                        attrs: {
                          getDataActionName: "getHistoryOrdersPagination",
                          haveStartDate: "",
                          isShowStartBtn: "",
                          isPagination: "",
                          startDate: _vm.startDate,
                          refresh: _vm.searchOrderHistoryRefresh,
                          startDateLabel: _vm.$t("processStartDate"),
                          searchBoxLabel: _vm.$t("orderId/sku"),
                          historyLimit: _vm.historyLimit,
                          actionPredicates: [
                            {
                              field: "keywords",
                              compare: "array-contains",
                              value: (
                                _vm.platform ||
                                _vm.searchOrderHistory ||
                                _vm.selectWord ||
                                ""
                              ).toLowerCase()
                            }
                          ]
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "beforeMenu",
                              fn: function() {
                                return [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", nowrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md3: "", "mr-1": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: [
                                                {
                                                  name: _vm.$t("keyword"),
                                                  value: "keyword"
                                                },
                                                {
                                                  name: _vm.$t("platform"),
                                                  value: "platform"
                                                },
                                                {
                                                  name: _vm.$t("label"),
                                                  value: "label"
                                                },
                                                {
                                                  name: _vm.$t("shipment"),
                                                  value: "shipping"
                                                }
                                              ],
                                              "item-value": "value",
                                              "item-text": "name",
                                              label: "Search Mode"
                                            },
                                            on: {
                                              change: function(e) {
                                                _vm.platform = ""
                                                _vm.searchOrderHistory = ""
                                                if (
                                                  e === "label" ||
                                                  e === "shipping"
                                                ) {
                                                  _vm.selectWord = e
                                                } else {
                                                  _vm.selectWord = ""
                                                }
                                              }
                                            },
                                            model: {
                                              value: _vm.orderHistoryMode,
                                              callback: function($$v) {
                                                _vm.orderHistoryMode = $$v
                                              },
                                              expression: "orderHistoryMode"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.orderHistoryMode === "keyword"
                                        ? _c(
                                            "v-flex",
                                            { attrs: { md4: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t("orderId/sku"),
                                                  clearable: ""
                                                },
                                                on: {
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    return function() {
                                                      _vm.searchOrderHistoryRefresh = !_vm.searchOrderHistoryRefresh
                                                    }.apply(null, arguments)
                                                  }
                                                },
                                                model: {
                                                  value: _vm.searchOrderHistory,
                                                  callback: function($$v) {
                                                    _vm.searchOrderHistory = $$v
                                                  },
                                                  expression:
                                                    "searchOrderHistory"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.orderHistoryMode === "platform"
                                        ? _c(
                                            "v-flex",
                                            { attrs: { md4: "" } },
                                            [
                                              _c("v-autocomplete", {
                                                attrs: {
                                                  items: _vm.platforms,
                                                  "item-value": "value",
                                                  "item-text": "name",
                                                  label: _vm.$t("platform")
                                                },
                                                model: {
                                                  value: _vm.platform,
                                                  callback: function($$v) {
                                                    _vm.platform = $$v
                                                  },
                                                  expression: "platform"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "afterDate",
                              fn: function() {
                                return [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary",
                                            disabled: !_vm.selectedHistoryOrders
                                              .length
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.exportOrdersShippingConfirm(
                                                {
                                                  orders:
                                                    _vm.selectedHistoryOrders
                                                }
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("exportSelectedOrders")
                                              ) +
                                              "(" +
                                              _vm._s(
                                                _vm.selectedHistoryOrders.length
                                              ) +
                                              ")\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          label: _vm.isMergePDF ? "PDF" : "ZIP"
                                        },
                                        model: {
                                          value: _vm.isMergePDF,
                                          callback: function($$v) {
                                            _vm.isMergePDF = $$v
                                          },
                                          expression: "isMergePDF"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c("LoaderButton", {
                                        attrs: {
                                          isSmall: "",
                                          buttonText: _vm.$t(
                                            "downloadLabelsNum",
                                            {
                                              selectedLabelsLength:
                                                _vm.selectedHistoryOrders.length
                                            }
                                          ),
                                          promiseAwait:
                                            _vm.downloadSelectedOrderLabels,
                                          disabled:
                                            _vm.selectedHistoryOrders.length ===
                                            0
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "dataTable",
                              fn: function() {
                                return [
                                  _c("v-data-table", {
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.historyOrders,
                                      "hide-actions": "",
                                      "item-key": "orderId",
                                      "select-all": "blue",
                                      expand: _vm.expand
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "checkbox-align-center",
                                                  on: {
                                                    click: function($event) {
                                                      props.selected = !props.selected
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          value: props.selected,
                                                          primary: "",
                                                          "hide-details": ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return function() {
                                                              props.selected = !props.selected
                                                            }.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("OrderDetail", {
                                                    attrs: {
                                                      orderType:
                                                        props.item.isMPS,
                                                      orderId:
                                                        props.item.orderName ||
                                                        props.item.orderId,
                                                      platform:
                                                        props.item.platform,
                                                      messages:
                                                        props.item.messages ||
                                                        [],
                                                      storeName:
                                                        props.item.storeName
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-start": "",
                                                        wrap: "",
                                                        "align-start": ""
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("orderDate")
                                                          ) +
                                                            ":\n                      " +
                                                            _vm._s(
                                                              _vm.toTimestampString(
                                                                props.item
                                                                  .purchaseDate
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "justify-start": "",
                                                        wrap: "",
                                                        "align-start": ""
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "processDate"
                                                            )
                                                          ) +
                                                            ":\n                      " +
                                                            _vm._s(
                                                              _vm.toTimestampString(
                                                                props.item
                                                                  .processTime
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                _vm._l(
                                                  props.item.items,
                                                  function(item, index) {
                                                    return _c(
                                                      "v-flex",
                                                      {
                                                        key: item.sku + index,
                                                        attrs: { row: "" }
                                                      },
                                                      [
                                                        _c("ProductWidget", {
                                                          attrs: {
                                                            name:
                                                              item.productName,
                                                            sku: [item.sku],
                                                            quantityShipped:
                                                              item.quantityShipped,
                                                            quantityPurchased:
                                                              item.quantityPurchased
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-layout", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.buyerName
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item
                                                            .recipientName
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item
                                                            .shipAddress1 +
                                                            props.item
                                                              .shipAddress2
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item.shipCity
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          props.item.shipState
                                                        ) +
                                                        " -\n                    " +
                                                        _vm._s(
                                                          props.item
                                                            .shipPostalCode
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item
                                                            .buyerPhoneNumber
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item
                                                            .shipServiceLevel
                                                        ) +
                                                        " /\n                    " +
                                                        _vm._s(
                                                          props.item
                                                            .isBusinessOrder
                                                            ? _vm.$t("business")
                                                            : _vm.$t("other")
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { wrap: "" } },
                                                    _vm._l(
                                                      props.item.shipments.reduce(
                                                        function(
                                                          preVal,
                                                          curVal
                                                        ) {
                                                          if (
                                                            !preVal.some(
                                                              function(ref) {
                                                                var trackingNumber =
                                                                  ref.trackingNumber

                                                                return (
                                                                  trackingNumber ===
                                                                  curVal.trackingNumber
                                                                )
                                                              }
                                                            )
                                                          ) {
                                                            preVal.push(curVal)
                                                          }
                                                          return preVal
                                                        },
                                                        []
                                                      ),
                                                      function(shipment) {
                                                        return _c(
                                                          "v-flex",
                                                          {
                                                            key:
                                                              shipment.key ||
                                                              shipment.labelKey +
                                                                shipment.orderItemId
                                                          },
                                                          [
                                                            _c(
                                                              "LabelTrackingDetailWidget",
                                                              {
                                                                attrs: {
                                                                  trackingNumber:
                                                                    _vm.getShipmentTracking(
                                                                      shipment
                                                                    ) !==
                                                                    "No tracking"
                                                                      ? _vm.getShipmentTracking(
                                                                          shipment
                                                                        )
                                                                      : "",
                                                                  status: _vm.getOrderTrackingDetail(
                                                                    props.item,
                                                                    (
                                                                      shipment.trackingNumber ||
                                                                      ""
                                                                    ).trim()
                                                                  ).status,
                                                                  carrier: _vm.getOrderTrackingDetail(
                                                                    props.item,
                                                                    (
                                                                      shipment.trackingNumber ||
                                                                      ""
                                                                    ).trim()
                                                                  ).carrier,
                                                                  details: _vm.getOrderTrackingDetail(
                                                                    props.item,
                                                                    (
                                                                      shipment.trackingNumber ||
                                                                      ""
                                                                    ).trim()
                                                                  )
                                                                    .trackingDetails
                                                                }
                                                              },
                                                              [
                                                                shipment.key
                                                                  ? _c("span", [
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              shipment.key
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " -\n                          " +
                                                                          _vm._s(
                                                                            _vm.getShipmentTracking(
                                                                              shipment
                                                                            )
                                                                          ) +
                                                                          " -\n                          " +
                                                                          _vm._s(
                                                                            shipment.status
                                                                          ) +
                                                                          "\n                        "
                                                                      )
                                                                    ])
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.selectedHistoryOrders,
                                      callback: function($$v) {
                                        _vm.selectedHistoryOrders = $$v
                                      },
                                      expression: "selectedHistoryOrders"
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.historyOrders,
                          callback: function($$v) {
                            _vm.historyOrders = $$v
                          },
                          expression: "historyOrders"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item === "canceled" && _vm.currentTab === "canceled"
                    ? _c("PaginationController", {
                        ref: "getHistoryCanceledOrdersPagination",
                        refInFor: true,
                        attrs: {
                          getDataActionName:
                            "getHistoryCanceledOrdersPagination",
                          haveStartDate: "",
                          isShowStartBtn: "",
                          isPagination: "",
                          startDate: _vm.startDate,
                          historyLimit: _vm.historyLimit
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "beforeMenu",
                              fn: function() {
                                return [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary",
                                            loading: _vm.deleteLoading,
                                            disabled: !_vm
                                              .selectedHistoryCanceledOrders
                                              .length
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteOrder(
                                                _vm.selectedHistoryCanceledOrders,
                                                "getHistoryCanceledOrdersPagination",
                                                true
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("delete")) +
                                              "(" +
                                              _vm._s(
                                                _vm
                                                  .selectedHistoryCanceledOrders
                                                  .length
                                              ) +
                                              ")\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary",
                                            loading: _vm.restoreLoading,
                                            disabled: !_vm
                                              .selectedHistoryCanceledOrders
                                              .length
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.restoreOrder(
                                                _vm.selectedHistoryCanceledOrders,
                                                "getHistoryCanceledOrdersPagination"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("restore")) +
                                              "(" +
                                              _vm._s(
                                                _vm
                                                  .selectedHistoryCanceledOrders
                                                  .length
                                              ) +
                                              ")\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "afterDate",
                              fn: function() {
                                return [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary",
                                            disabled: !_vm
                                              .selectedHistoryCanceledOrders
                                              .length
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.exportOrdersShippingConfirm(
                                                {
                                                  orders:
                                                    _vm.selectedHistoryCanceledOrders
                                                }
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("exportSelectedOrders")
                                              ) +
                                              "(" +
                                              _vm._s(
                                                _vm
                                                  .selectedHistoryCanceledOrders
                                                  .length
                                              ) +
                                              ")\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "dataTable",
                              fn: function() {
                                return [
                                  _c("v-data-table", {
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.historyCancelOrders,
                                      "hide-actions": "",
                                      "item-key": "orderId",
                                      "select-all": "blue",
                                      expand: _vm.expand
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "checkbox-align-center",
                                                  on: {
                                                    click: function($event) {
                                                      !props.item.isDisabled &&
                                                        (props.selected = !props.selected)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          disabled:
                                                            props.item
                                                              .isDisabled,
                                                          value: props.selected,
                                                          primary: "",
                                                          "hide-details": ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return function() {
                                                              props.selected = !props.selected
                                                            }.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.toTimestampString(
                                                        props.item.purchaseDate
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("OrderDetail", {
                                                    attrs: {
                                                      orderType:
                                                        props.item.isMPS,
                                                      storeName:
                                                        props.item.storeName,
                                                      orderId:
                                                        props.item.orderName ||
                                                        props.item.orderId,
                                                      platform:
                                                        props.item.platform,
                                                      messages:
                                                        props.item.messages,
                                                      orderStatus:
                                                        props.item.cancelState
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  !!props.item.error
                                                    ? _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            "justify-start": "",
                                                            wrap: "",
                                                            "align-start": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color: "red"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Shipment Error: " +
                                                                  _vm._s(
                                                                    props.item
                                                                      .error
                                                                      .message
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                _vm._l(
                                                  props.item.items,
                                                  function(item, index) {
                                                    return _c(
                                                      "v-flex",
                                                      {
                                                        key: item.sku + index,
                                                        attrs: { row: "" }
                                                      },
                                                      [
                                                        _c("ProductWidget", {
                                                          attrs: {
                                                            name:
                                                              item.productName,
                                                            sku: [item.sku],
                                                            quantityShipped:
                                                              item.quantityShipped,
                                                            quantityPurchased:
                                                              item.quantityPurchased,
                                                            status:
                                                              item.productStatus,
                                                            isMatchingExactly:
                                                              props.item
                                                                .exactMatchTemplate,
                                                            isSupportChanged: ""
                                                          },
                                                          on: {
                                                            "submit-quantity": function(
                                                              value
                                                            ) {
                                                              return _vm.updateQuantity(
                                                                props.item
                                                                  .orderId,
                                                                item.orderItemId,
                                                                value
                                                              )
                                                            }
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "sku",
                                                                fn: function() {
                                                                  return [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "ml-2"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            on: {
                                                                              click: function() {
                                                                                _vm.filter =
                                                                                  item.sku
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.sku
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                },
                                                                proxy: true
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-layout",
                                                          [
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                staticClass:
                                                                  "text-sm-left"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "shipBy"
                                                                    )
                                                                  ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      _vm.toDateString(
                                                                        props
                                                                          .item
                                                                          .promiseDate
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-layout", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.buyerName
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item
                                                            .recipientName
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item
                                                            .shipAddress1 +
                                                            props.item
                                                              .shipAddress2
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item.shipCity
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          props.item.shipState
                                                        ) +
                                                        " -\n                  " +
                                                        _vm._s(
                                                          props.item
                                                            .shipPostalCode
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          props.item
                                                            .buyerPhoneNumber
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-layout", [
                                                    _c(
                                                      "span",
                                                      {
                                                        style:
                                                          "color: " +
                                                          (props.item
                                                            .shipServiceLevel ===
                                                            "ShippingMethodExpress" ||
                                                          (props.item
                                                            .platform ===
                                                            "Amazon" &&
                                                            props.item
                                                              .shipServiceLevel ===
                                                              "NextDay") ||
                                                          (props.item
                                                            .platform ===
                                                            "Amazon" &&
                                                            props.item
                                                              .shipServiceLevel ===
                                                              "SecondDay") ||
                                                          props.item
                                                            .shipServiceLevel ===
                                                            "Express"
                                                            ? "red"
                                                            : "black")
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item
                                                              .shipServiceLevel
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        "/" +
                                                          _vm._s(
                                                            props.item
                                                              .isBusinessOrder
                                                              ? _vm.$t(
                                                                  "business"
                                                                )
                                                              : _vm.$t("other")
                                                          )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        flat: "",
                                                        dark: "",
                                                        color: "primary",
                                                        loading:
                                                          props.item.loading
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.deleteOrder(
                                                            [props.item],
                                                            "getHistoryCanceledOrdersPagination"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("delete")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        flat: "",
                                                        dark: "",
                                                        color: "primary",
                                                        loading:
                                                          props.item
                                                            .restoreLoading
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.restoreOrder(
                                                            [props.item],
                                                            "getHistoryCanceledOrdersPagination"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("restore")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.selectedHistoryCanceledOrders,
                                      callback: function($$v) {
                                        _vm.selectedHistoryCanceledOrders = $$v
                                      },
                                      expression:
                                        "selectedHistoryCanceledOrders"
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.historyCancelOrders,
                          callback: function($$v) {
                            _vm.historyCancelOrders = $$v
                          },
                          expression: "historyCancelOrders"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.revisePkgDialog
        ? _c("ModifyPkgSpecificationPopup", {
            attrs: { order: _vm.currentRevisePkgOrder },
            on: {
              "update:order": function($event) {
                _vm.currentRevisePkgOrder = $event
              },
              updateOrders: function(order) {
                return _vm.updateOrders(order)
              },
              popupClose: function($event) {
                _vm.currentRevisePkgOrder = {}
              }
            },
            model: {
              value: _vm.revisePkgDialog,
              callback: function($$v) {
                _vm.revisePkgDialog = $$v
              },
              expression: "revisePkgDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddShipmentDialog
        ? _c("OrderAddShipment", {
            attrs: {
              selectedOrder: _vm.selectedOrder,
              template: _vm.selectedTemplate
            },
            model: {
              value: _vm.showAddShipmentDialog,
              callback: function($$v) {
                _vm.showAddShipmentDialog = $$v
              },
              expression: "showAddShipmentDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buyShippingDialog
        ? _c("BuyShippingPopup", {
            attrs: { selectedOrders: _vm.selectedOrders },
            on: {
              "update:selectedOrders": function($event) {
                _vm.selectedOrders = $event
              },
              "update:selected-orders": function($event) {
                _vm.selectedOrders = $event
              },
              submitted: _vm.clearSelectedOrders
            },
            model: {
              value: _vm.buyShippingDialog,
              callback: function($$v) {
                _vm.buyShippingDialog = $$v
              },
              expression: "buyShippingDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buyLabelDialog
        ? _c("BuyLabelPopup", {
            attrs: { selectedOrders: _vm.selectedOrders },
            on: {
              "update:selectedOrders": function($event) {
                _vm.selectedOrders = $event
              },
              "update:selected-orders": function($event) {
                _vm.selectedOrders = $event
              },
              submitted: _vm.clearSelectedOrders
            },
            model: {
              value: _vm.buyLabelDialog,
              callback: function($$v) {
                _vm.buyLabelDialog = $$v
              },
              expression: "buyLabelDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.createTemplateDialog
        ? _c("LabelTemplatePopup", {
            attrs: { initTemplate: _vm.templateInEdit },
            model: {
              value: _vm.createTemplateDialog,
              callback: function($$v) {
                _vm.createTemplateDialog = $$v
              },
              expression: "createTemplateDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editBuyShippingDialog
        ? _c("EditBuyShippingPopup", {
            attrs: {
              selectedOrders: _vm.editSelectedOrders,
              editSelectedItems: _vm.editSelectedItems
            },
            on: {
              "update:selectedOrders": function($event) {
                _vm.editSelectedOrders = $event
              },
              "update:selected-orders": function($event) {
                _vm.editSelectedOrders = $event
              },
              submitted: _vm.clearEditSelectedOrders
            },
            model: {
              value: _vm.editBuyShippingDialog,
              callback: function($$v) {
                _vm.editBuyShippingDialog = $$v
              },
              expression: "editBuyShippingDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("exportOrders"),
          value: _vm.exportOrdersPopup.show,
          rightMethod: _vm.exportOrdersShipping,
          rightButtonText: _vm.$t("export"),
          small: "",
          hasAlert: ""
        },
        on: {
          popupClose: function($event) {
            _vm.exportOrdersPopup.show = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-select", {
                          attrs: {
                            label: _vm.$t("status"),
                            items: _vm.orderStatuses,
                            "item-text": "label"
                          },
                          model: {
                            value: _vm.exportOrdersPopup.status,
                            callback: function($$v) {
                              _vm.$set(_vm.exportOrdersPopup, "status", $$v)
                            },
                            expression: "exportOrdersPopup.status"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "justify-space-between": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md4: "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            label: _vm.$t("dateType"),
                            items: _vm.dateTypes,
                            "item-text": "label"
                          },
                          model: {
                            value: _vm.exportOrdersPopup.dateType,
                            callback: function($$v) {
                              _vm.$set(_vm.exportOrdersPopup, "dateType", $$v)
                            },
                            expression: "exportOrdersPopup.dateType"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md7: "" } },
                      [
                        _c("DatePicker", {
                          attrs: {
                            isShowIcon: false,
                            label: _vm.$t("date"),
                            range: "",
                            max: _vm.dateMax,
                            min: _vm.dateMin
                          },
                          model: {
                            value: _vm.exportOrdersPopup.dates,
                            callback: function($$v) {
                              _vm.$set(_vm.exportOrdersPopup, "dates", $$v)
                            },
                            expression: "exportOrdersPopup.dates"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("remarkOrder"),
          rightMethod: _vm.remarkOrder,
          rightButtonText: _vm.$t("submit"),
          small: "",
          hasAlert: ""
        },
        on: {
          popupClose: function($event) {
            _vm.remarkOrderPopup.show = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _vm.remarkOrderPopup.order
                          ? _c("v-textarea", {
                              attrs: {
                                label: _vm.$t("remark"),
                                "hide-details": "",
                                clearable: ""
                              },
                              model: {
                                value: _vm.remarkOrderPopup.order.remark,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.remarkOrderPopup.order,
                                    "remark",
                                    $$v
                                  )
                                },
                                expression: "remarkOrderPopup.order.remark"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.remarkOrderPopup.show,
          callback: function($$v) {
            _vm.$set(_vm.remarkOrderPopup, "show", $$v)
          },
          expression: "remarkOrderPopup.show"
        }
      }),
      _vm._v(" "),
      _c("SplitOrderPopup", { ref: "splitOrderPopup" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-386fc4c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386fc4c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TenantOrder.vue
// module id = null
// module chunks = 